<template>
	<div class="main-content" v-loading="loading">
		<div class="orderlist" v-if="!loading">
			<div class="panel-body">
				<div class="search-bar">
					<el-form :inline="true" class="demo-form-inline" style='margin-bottom: -22px;'>
						<el-form-item label="订单号">
							<el-input v-model="order_no" placeholder="订单号"></el-input>
						</el-form-item>
						<el-form-item label="商品名称">
							<el-input v-model="keyword" placeholder="商品名称"></el-input>
						</el-form-item>
						<el-form-item label="助记码">
							<el-input v-model="mnemonic_code" placeholder="助记码"></el-input>
						</el-form-item>
            <div style="display: inline-block;">要货日期</div>
            <el-date-picker
                  v-model="order_date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        style='margin-right: 10px;'
                  >
                </el-date-picker>
            <!-- <el-date-picker
                  v-model="order_date_start"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>-
                <el-date-picker
                      v-model="order_date_end"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker> -->
						<el-form-item>
							<el-button type="primary" @click='handleClick()'>查询</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="resetData()">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<el-tabs v-model="status" @tab-click="handleClick()">
				<el-tab-pane label="全部订单" name=""> </el-tab-pane>
				<el-tab-pane label="待审核" name="10"> </el-tab-pane>
				<el-tab-pane label="待发货" name="20"></el-tab-pane>
				<el-tab-pane label="待收货" name="30"></el-tab-pane>
				<el-tab-pane label="已收货" name="40"></el-tab-pane>
				<el-tab-pane label="审核未通过" name="21"></el-tab-pane>
			</el-tabs>
			<div class="order-table table-heard">
				<div class="order-th">订单号</div>
				<div class="order-th">要货日期</div>
				<div class="order-th">订货总数量</div>
				<div class="order-th">总金额</div>
				<div class="order-th">订单状态</div>
				<div class="order-th">查看详情</div>
				<div class="order-th">操作</div>
				<!-- 				<div class="order-th">件数</div>
				<div class="order-th">单价</div>
				<div class="order-th">金额</div> -->
				<!-- <div class="order-th">操作</div> -->
			</div>
			<div class="order-conter">
				<div class="order-list" v-if='list.length>0'>
					<div class="order-item" v-for="(item,index) in list" :key="item.id">
						<div class="order-table">
							<div class="order-th">{{item.order_no}}</div>
							<div class="order-th">{{item.order_demand_format}}</div>
							<div class="order-th">{{item.sale_price_unit_qty}}</div>
							<div class="order-th">{{item.total_price}}</div>
							<div class="order-th">{{item.status_label}}</div>
							<div class="order-th">
								<router-link :to="{name:'orderview',query:{'id':item.id}}" style="color: rgba(63, 81, 181, 1);">查看详情</router-link>
							</div>
							<div class="order-th">
								<div class="delete-order" @click="deleteOrder(index)" v-if="item.status=='10'||item.status=='21'">删除订单</div>
							</div>
						</div>
						<!-- <div class="order-info">
						订单编号:{{item.order_no}} <span class="ml20"> 要货日期：{{item.order_demand_format}}</span>
						<button class="delete-order" @click="deleteOrder(index)" v-if="item.status=='10'||item.status=='21'">删除订单</button>
						<span class="order-detail">
							<router-link :to="{name:'orderview',query:{'id':item.id}}" style="color: rgba(63, 81, 181, 1);">查看详情</router-link>
						</span>
						<span class="order-status">{{item.status_label}}</span>

					</div> -->
						<!-- <div class="order-table" v-for="(sku,skuindex) in item.skus" >
						<div class="order-th" style="flex: 2;">{{sku.name}}</div>
						<div class="order-th">{{sku.sku_name}}</div>
						<div class="order-th">{{sku.mnemonic_code}}</div>
						<div class="order-th">{{sku.barcode}}</div>
						<div class="order-th">{{sku.sale_price_unit_qty}}</div>
						<div class="order-th">{{sku.sale_price_unit}}</div>
						<div class="order-th">{{sku.sale_unit_qty}}</div>
						<div class="order-th">{{sku.price}}</div>
						<div class="order-th">{{sku.subtotal_price}}</div>

					</div> -->
					</div>
				</div>
				<div v-else class="empty-data">--暂无数据--</div>
				<div class="pagination-change" v-if="page_count>1">
					<el-pagination @size-change="reload" @current-change="reload" :current-page.sync="page" :page-size="page_size"
					 layout="prev, pager, next, jumper" :total="page_total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "orderlist",
		data() {
			return {
				status: '',
				loading: true,
				page: 1,
				page_total: 0,
				page_size: 10,
				page_count: 1,
				keyword: '',
				mnemonic_code: '',
				order_no: '',
        order_date:['',''],
				list: []
			};
		},
		created: function() {
			this.status = this.$route.query.status || '';
			this.reload();
		},
		methods: {
			reload: function() {
        console.log('11111111',this.order_date)
				var params = {
					status: this.status,
					keyword: this.keyword,
					mnemonic_code: this.mnemonic_code,
					page: this.page,
					page_size: this.page_size,
					order_no: this.order_no,
          order_date_start:this.order_date[0],
          order_date_end:this.order_date[1]
				}
				this.https.fetchGet('/pc/service/trade/order/search', params)
					.then((res) => {
						if (res.data.success) {
							var data = res.data.content;
							this.list = data.items;
							this.page_count = data.page_count;
							this.page_total = data.page_count * this.page_size;
							this.loading = false;
						}

					}).catch(err => {
						console.log(err)
					})
			},
			handleClick: function() {
				this.page = 1;
				this.reload();
			},
			//重置
			resetData: function() {
				this.keyword = '',
					this.mnemonic_code = '';
				this.order_no = '';
        this.order_date=['',''];
				this.handleClick();
			},
			//删除订单
			deleteOrder: function(index) {
				var params = {
					order_id: this.list[index].id
				}
				this.$confirm('是否要删除该订单', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.https.fetchPost('/pc/service/trade/order/delete', params)
						.then((res) => {
							if (res.data.success) {
								//this.list.splice(index,1)
								this.reload();
							}

						}).catch(err => {
							console.log(err)
						})
				}).catch(err => {
					console.log(err)
				})
			}
		}
	};
</script>

<style scoped="">
	.ml20 {
		margin-left: 20px;
	}

	.panel-body {
		padding: 20px;
		background: #fff;
	}

/* 	.search-bar {
		width: 1180px;
	} */

	.orderlist {
		padding: 20px;
	}

	.order-status {
		float: right;
		color: red;
	}

	.order-conter {
		position: relative;
		padding-bottom: 50px;
	}

	.order-table {
		display: flex;
		width: 100%;
		border-top: 1px solid #d9d9d9;
	}

	.table-heard {
		background: rgb(74, 144, 138);
		margin-bottom: 20px;
		color: #fff;
	}

	.order-th {
		flex: 1;
		padding: 10px;
		text-align: center;
	}

	.order-item {
		border: 1px solid #D9D9D9;
		margin-bottom: 20px;
	}

	.order-info {
		background-color: #e9e9e9;
		padding: 10px 20px;
	}

	.order-th {
		flex: 1;
		padding: 10px;
		text-align: center;
	}

	.order-detail {
		float: right;
		color: rgba(63, 81, 181, 1);
		margin-left: 20px;
		cursor: pointer;
	}

	.order-list {
		max-height: 700px;
		overflow-y: auto;
	}

	.pagination-change {
		padding: 10px 0;
		background: #fff;
		text-align: right;
		width: 100%;
		right: 0;
	}

	.empty-data {
		text-align: center;
		background: #fff;
		padding: 100px;
		color: #999;
	}

	.delete-order {
		padding: 5px 20px;
		color: red;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/views/order-list.vue